import React from 'react';
import PropTypes from 'prop-types';
import { take } from 'lodash';

import useWindowDimensions from 'hooks/useWindowDimensions';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import 'screens/Integrations/components/integrationTooltip.css';
import Tag from 'screens/Integrations/components/IntegrationTag';

const numberOfDisplayedCropSeasons = width => {
  if (width <= 1410) return 1;
  if (width >= 1411 && width <= 1599) return 2;
  return 3;
};

const cropSeasonsTagsDefaultPropCropSeasons = [];
const CropSeasonsTags = ({
  cropSeasons = cropSeasonsTagsDefaultPropCropSeasons
}) => {
  const { width } = useWindowDimensions();

  const cropSeasonsToDisplay = take(
    cropSeasons,
    numberOfDisplayedCropSeasons(width)
  );

  const cropSeasonsRemaining = cropSeasons.filter(
    season =>
      !cropSeasonsToDisplay.some(
        seasonDisplay => seasonDisplay.id === season.id
      )
  );

  return (
    <div className="flex gap-2 justify-start">
      {cropSeasonsToDisplay.map(cropSeason => (
        <div key={cropSeason.id} className="w-auto">
          <Tag color="#696F88">
            <span className="p-2">{cropSeason.name}</span>
          </Tag>
        </div>
      ))}
      {cropSeasonsRemaining.length > 0 && (
        <Tooltip
          overlayClassName="integration-tooltip"
          placement="top"
          align={{ offset: [0, 6] }}
          color="#232630"
          overlayStyle={{ maxWidth: 'none' }}
          title={
            <div className="text-xs text-white" style={{ width: '10rem' }}>
              {cropSeasonsRemaining.map(season => season.name).join(', ')}
            </div>
          }
        >
          <span className="font-bold" data-testid="size-remaining">
            +{cropSeasonsRemaining.length}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

CropSeasonsTags.propTypes = {
  cropSeasons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  )
};

export default CropSeasonsTags;
